import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";

  var
    datas = {};

  amplify.subscribe("familyScopeChange",function(){
    datas = {};
  });
  amplify.subscribe("notificationBullet",function(key,value){
    if(datas[key]!==value){
      datas[key]=value;
      const elements = document.querySelectorAll<HTMLElement>('*[data-notification-key="'+key+'"]');
      elements.forEach(el => {
        el.innerHTML = value;
        if(value){
          Html.fadeIn(el);
        }else{
          Html.fadeOut(el);
        }
      });
    }
  });
  amplify.subscribe("notificationBulletDelta",function(key,value){
    amplify.publish("notificationBullet",key,datas[key] + value);
  });
function initDom(obj: HTMLElement){
  const key = obj.getAttribute('data-notification-key');
  if(datas[key]){
    obj.innerHTML = datas[key];
    obj.style.display = '';
  }else{
    obj.innerHTML = datas[key] || '';
    obj.style.display = 'none';
  }
}
function get(key){
  return datas[key];
}

Html.registerWidget('widget/notification-bullet',{initDom})

export {get};